import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './config/i18n'; // Initialize i18n before rendering

// Sentry: initialize only when DSN is present in the environment.
// To enable: set REACT_APP_SENTRY_DSN in Koyeb environment variables.
// Install SDK first: npm install @sentry/react
// Then uncomment the block below:
//
// import * as Sentry from '@sentry/react';
// const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
// if (sentryDsn && sentryDsn !== '{{SENTRY_DSN}}') {
//   Sentry.init({
//     dsn: sentryDsn,
//     environment: process.env.NODE_ENV,
//     tracesSampleRate: 0.1, // 10% of transactions for performance monitoring
//     replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors
//   });
// }

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
